module.exports = __webpack_public_path__ + "static/media/app-store.e4524740.svg";